import React from "react";
import { cls } from "@wss/cls";
import { VariationGroup, VariationGroupItem } from "./ProductDetailPageResult";
import ThumbnailVariationItem from "./ThumbnailVariationItem";
import DisplayTypes from "./DisplayTypes";
interface ThumbnailVariationProps {
  group: VariationGroup;
  lowerCaseItemNumber: string;
  getHrefTarget: (groupItem: VariationGroupItem, isSelected: boolean) => string;
  sortGroupItems: (group: VariationGroup, a: VariationGroupItem, b: VariationGroupItem) => number;
  displayTypeId?: number;
}
const ThumbnailVariation = ({
  group,
  lowerCaseItemNumber,
  getHrefTarget,
  sortGroupItems,
  displayTypeId
}: ThumbnailVariationProps) => {
  const selectedGroupItem = group.variationGroupItems.find(groupItem => groupItem.itemNumber === lowerCaseItemNumber);
  group.variationGroupItems.sort((a, b) => sortGroupItems(group, a, b));
  const defaultActiveItemNumber = selectedGroupItem?.itemNumber ?? "";
  const [activeItemNumber, setActiveItemNumber] = React.useState<string>(defaultActiveItemNumber);
  const [focusedItemNumber, setFocusedItemNumber] = React.useState<string | null>(null);
  const updateActiveItemNumber = (itemNumber: string | undefined) => {
    const newActiveItemNumber = itemNumber ?? focusedItemNumber ?? defaultActiveItemNumber;
    setActiveItemNumber(newActiveItemNumber);
  };
  const handleFocus = (itemNumber: string) => {
    setFocusedItemNumber(itemNumber);
    updateActiveItemNumber(itemNumber);
  };
  const handleBlur = () => {
    setFocusedItemNumber(null);
    updateActiveItemNumber(defaultActiveItemNumber);
  };
  const variationText = group.variationGroupItems.find(item => item.itemNumber === activeItemNumber)?.variationText ?? "";
  const shouldDisplayVariationText = group.displayTypeId === DisplayTypes.ImageAndLabel;
  return <>
      <h2 data-testid="productVariationsHeading" id="productVariationsHeading" className="mb-1 text-sm">
        <>
          {`${group.optionName}: `}
          <span className="font-normal">{variationText}</span>
        </>
      </h2>
      <ul id="suffixhold" className={cls("grid", "m-0", "overflow-y-auto", "overflow-x-hidden", "p-0", "gap-2", "grid-cols-4", "xs:grid-cols-5", "lt:grid-cols-3", "[@media(min-width:1150px)]:grid-cols-4", "h-full")} style={{
      maxHeight: shouldDisplayVariationText ? "17rem" : "15rem"
    }} aria-labelledby="productVariationsHeading">
        {group.variationGroupItems.map(groupItem => <ThumbnailVariationItem key={`${group.id ?? "0"}.${group.optionName}.${groupItem.itemNumber}`} groupItem={groupItem} isSelected={groupItem.itemNumber === lowerCaseItemNumber} variationGroup={group} getHrefTarget={getHrefTarget} updateActiveItemNumber={updateActiveItemNumber} onFocus={handleFocus} onBlur={handleBlur} displayTypeId={displayTypeId} />)}
      </ul>
    </>;
};
export default ThumbnailVariation;